import React from "react"
import cx from "classnames"
import Link from "./Link"
import PropTypes from 'prop-types';

const Badge = ({ children, to, type = "violet", square = false, className = "", blank = false }) => {
  const classes = cx("py-0.25 rounded-full text-small font-medium inline-block", classStyle[type], square ? '!rounded px-1' : 'px-2', className)

  return to ? <Link to={to} className={classes} blank={blank}>{children}</Link> : <span className={classes}>{children}</span>
}

Badge.propTypes = {
  children: PropTypes.element,
  to: PropTypes.string,
  type: PropTypes.oneOf(["violet", "blue", "turquoise", "white", "grey", "lightgrey"]),
  square: PropTypes.bool,
  className: PropTypes.string,
  blank: PropTypes.bool
}

export default Badge

const classStyle = {
  "violet": "bg-violet-60 text-violet-20",
  "blue": "bg-blue-50 text-blue-10",
  "turquoise": "bg-turquoise-50 text-blue-10",
  "white": "bg-blue-60 text-midnight-10",
  "grey": "bg-midnight-50 text-midnight-10",
  "lightgrey": "bg-blue-60 text-midnight-10",
}